import { Button, Intent, Popover, PopoverInteractionKind, Position, Size, Tooltip } from "@blueprintjs/core"
import MeatSelectorList from "../../MeatSelectorList"
import updateHistory from "../../utils/updateHistory"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { __ } from "src/libs/utilities"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import createMeat from "../../utils/createMeat"
import { HasId } from "src/libs/interfaces/layouts"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface IAddMeatAfterProps {
   height: number
   width: number
   section?: ILandingSection
   data?: HasId
   isHorizontal?: boolean
}
const AddMeatAfter = (props: IAddMeatAfterProps): JSX.Element => {
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding )
    const onNewMeat = (evt: any, key: string, n: number = 0) => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : __("Add new Meat ") + __(components()[key].title),
        } 
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((section, i) => {
                if(props.section?.id === section.id) { 
                    const index = section.data.findIndex((d, ii) => d.id === props.data?.id )  
                    historyStep.prevData = JSON.parse(JSON.stringify(section ))
                    const newData = createMeat(key, n, {})
                    section.data.splice(index + 1, 0, newData)
                    historyStep.data = { ...section }
                    return section  
                }        
                return section
            })
        }    
        updateHistory( historyStep, newLanding )
    }

    return <div 
        className="position-absolute z-index-80"        
        style={props.isHorizontal ? { top:props.height / 2 - 24, right: props.width } : { top: props.height, right: "50%" }}
    >
        <Tooltip
            intent={Intent.PRIMARY}
            position="top-left"
            content={__("Add meat after this")}
        >
            <Popover 
                position={ Position.LEFT_TOP }
                interactionKind={ PopoverInteractionKind.CLICK }
                content={ <MeatSelectorList onClick={onNewMeat} /> } 
                portalClassName="" 
                className={`edit-button-popover ${ true ? "" : "pe-surface2" }`}
            >
                <Button 
                    icon="plus" 
                    className={`edit-button add-bottom-after${props.isHorizontal ? '-hor' : ''}`} 
                    size={ Size.SMALL }
                    
                >
                    
                </Button>
            </Popover> 
        </Tooltip>
    </div>
}
export default AddMeatAfter